
// PDFReport.jsx
import { Page, Text, View, Document, Image, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: "Helvetica",
    borderWidth: 2,
    borderColor: "#F6AF42",
  },
  header: {
    fontSize: 22,
    textAlign: "center",
    marginBottom: 20,
    fontWeight: "bold",
    color: "#F6AF42",
  },
  sectionTitle: {
    fontSize: 16,
    marginBottom: 8,
    fontWeight: "bold",
    paddingBottom: 4,
    color: "#333",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  tableContainer: {
    marginTop: 8,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 4,
    wrap: false,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F6AF42",
    padding: 4,
  },
  tableHeaderText: {
    fontWeight: "bold",
    fontSize: 11,
    flex: 1,
    color: "#fff",
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    padding: 4,
  },
  tableCell: {
    flex: 1,
    fontSize: 11,
    color: "#333",
    textAlign: "center",
  },
  chartImage: {
    marginTop: 12,
    width: "100%",
    height: 250,
    objectFit: "contain",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    color: "#888",
  },
});

const PDFReport = ({ reportSections, chartImages }) => {
  return (
    <Document>
      {reportSections.map((section, idx) => (
        <Page key={idx} size="A4" style={styles.page}>
          {/* Header only on first page */}
          {idx === 0 && <Text style={styles.header}>Vaisnava Marriage Report</Text>}

          {/* Section Title */}
          <Text style={styles.sectionTitle}>{section.title}</Text>

          {/* Table */}
          <View style={styles.tableContainer}>
            <View style={styles.tableHeader}>
              <Text style={styles.tableHeaderText}>Label</Text>
              <Text style={styles.tableHeaderText}>Total</Text>

              {section.tableType === "gender" && (
                <>
                  <Text style={styles.tableHeaderText}>Male</Text>
                  <Text style={styles.tableHeaderText}>Female</Text>
                </>
              )}

              {section.tableType === "adminUser" && (
                <>
                  <Text style={styles.tableHeaderText}>Admin</Text>
                  <Text style={styles.tableHeaderText}>User</Text>
                </>
              )}
            </View>

            {/* Table Rows */}
            {section.metrics.map((metric, idx2) => (
              <View key={idx2} style={styles.tableRow}>
                <Text style={styles.tableCell}>{metric.label}</Text>
                <Text style={styles.tableCell}>{metric.value}</Text>

                {section.tableType === "gender" && (
                  <>
                    <Text style={styles.tableCell}>{metric.male}</Text>
                    <Text style={styles.tableCell}>{metric.female}</Text>
                  </>
                )}

                {section.tableType === "adminUser" && (
                  <>
                    <Text style={styles.tableCell}>{metric.admin}</Text>
                    <Text style={styles.tableCell}>{metric.user}</Text>
                  </>
                )}
              </View>
            ))}
          </View>

          {/* Chart Image */}
          {chartImages && chartImages[section.title] && (
            <Image src={chartImages[section.title]} style={styles.chartImage} />
          )}

          {/* Footer */}
          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages} — Generated by Vaisnava Marriage`
            }
            fixed
          />
        </Page>
      ))}
    </Document>
  );
};

export default PDFReport;
